var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttempt5Badge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 18,
    rx: 7.5,
    stroke: "#3260D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.78 14.108C10.324 14.108 9.868 14.04 9.412 13.904C8.964 13.768 8.556 13.556 8.188 13.268C8.092 13.204 8.028 13.128 7.996 13.04C7.964 12.952 7.96 12.864 7.984 12.776C8.008 12.688 8.052 12.616 8.116 12.56C8.18 12.496 8.256 12.46 8.344 12.452C8.44 12.444 8.54 12.476 8.644 12.548C8.972 12.78 9.312 12.952 9.664 13.064C10.016 13.176 10.384 13.232 10.768 13.232C11.16 13.232 11.496 13.16 11.776 13.016C12.064 12.864 12.28 12.656 12.424 12.392C12.576 12.12 12.652 11.804 12.652 11.444C12.652 10.892 12.492 10.44 12.172 10.088C11.852 9.736 11.412 9.56 10.852 9.56C10.508 9.56 10.192 9.624 9.904 9.752C9.616 9.88 9.352 10.084 9.112 10.364C9.056 10.428 8.988 10.484 8.908 10.532C8.836 10.572 8.752 10.592 8.656 10.592C8.52 10.592 8.412 10.556 8.332 10.484C8.26 10.404 8.224 10.3 8.224 10.172V5.996C8.224 5.844 8.264 5.732 8.344 5.66C8.424 5.58 8.536 5.54 8.68 5.54H12.76C12.912 5.54 13.024 5.576 13.096 5.648C13.176 5.72 13.216 5.824 13.216 5.96C13.216 6.096 13.176 6.2 13.096 6.272C13.024 6.344 12.912 6.38 12.76 6.38H9.196V9.752H8.932C9.14 9.416 9.428 9.16 9.796 8.984C10.164 8.8 10.576 8.708 11.032 8.708C11.568 8.708 12.028 8.82 12.412 9.044C12.804 9.268 13.104 9.584 13.312 9.992C13.528 10.392 13.636 10.86 13.636 11.396C13.636 11.924 13.52 12.392 13.288 12.8C13.056 13.208 12.728 13.528 12.304 13.76C11.88 13.992 11.372 14.108 10.78 14.108Z",
    fill: "#3260D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttempt5Badge);
export default __webpack_public_path__ + "static/media/attempt-5-badge.e6adc95d7b0bb4d30d5cc020a5f1f35f.svg";
export { ForwardRef as ReactComponent };